(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbg-motif-configurator"] && !Shopify.designMode) return;
  try {
    (function () {
    const designs = ['Contemporary','Craftsman','Mediterranean','Traditional'];
    const scopedIds = ["10660274602148","10660272898212","10660274634916","10660274700452","10660274798756","10660272930980","10660274897060"];
    const resolveSelection = (variants,expected,motif,finish,voltage,voltages) => {
      const binding = expected.find(item => item.motif === motif && item.finish === finish);
      const variant = binding ? variants.find(item => item.sku === binding.sku && item.options[0] === motif && item.options[1] === finish) : null;
      const valid = designs.includes(motif) && voltages.includes(voltage) && variants.length === expected.length && variant && variant.available;
      return {motif,finish,voltage,variant,valid:Boolean(valid)};
    };
    function initialize() {
      document.querySelectorAll('[data-bbg-motif]').forEach(root => {
        if (root.dataset.initialized) return;
        const form = root.closest('form');
        const data = JSON.parse(root.querySelector('[data-bbg-motif-data]').textContent);
        if (!form || !scopedIds.includes(String(data.productId))) return;
        root.dataset.initialized = 'true';
        const motif = root.querySelector('[data-bbg-motif-value]');
        const finish = root.querySelector('[data-bbg-finish]');
        const voltage = root.querySelector('[data-bbg-voltage]');
        const menu = root.querySelector('details');
        const summary = root.querySelector('summary');
        const text = root.querySelector('[data-bbg-motif-selection]');
        const selectedImage = root.querySelector('.bbg-motif-selected-image');
        const error = root.querySelector('.bbg-motif-error');
        const buttons = Array.from(root.querySelectorAll('[data-bbg-design]'));
        function imageFor(design) {
          const alt = design + ' - ' + (finish.value === 'Black' ? 'Black' : 'Stainless');
          return data.images.find(image => image.alt.replace(/\s*-\s*/g,' - ') === alt);
        }
        function resolve() {
          return resolveSelection(data.variants,data.expected,motif.value,finish.value,voltage.value,data.voltages);
        }
        function update() {
          buttons.forEach(button => {
            const image = imageFor(button.dataset.bbgDesign);
            const img = button.querySelector('img');
            if (image && img) { img.src = image.url; img.removeAttribute('srcset'); img.alt = image.alt; }
            button.setAttribute('aria-pressed',String(button.dataset.bbgDesign === motif.value));
          });
          root.querySelector('[data-bbg-preview-note]').hidden = Boolean(finish.value);
          const image = imageFor(motif.value);
          if (image && motif.value) { selectedImage.src = image.url; selectedImage.alt = image.alt; selectedImage.hidden = false; }
          else selectedImage.hidden = true;
          const chosen = resolve();
          root.querySelector('[data-bbg-sku]').textContent = chosen.variant ? chosen.variant.sku : '—';
          error.hidden = true;
          if (!chosen.variant) return;
          const native = Array.from(form.querySelectorAll('[data-option]'));
          native.forEach(input => {
            const group = input.closest('[data-option-index]');
            const index = group ? Number(group.getAttribute('data-option-index')) : Number(input.getAttribute('data-option').replace('option','')) - 1;
            if (input.type === 'radio') input.checked = input.value === chosen.variant.options[index];
            else input.value = chosen.variant.options[index];
          });
          if (native.length) native.find(input => input.type !== 'radio' || input.checked)?.dispatchEvent(new Event('change',{bubbles:true}));
          const id = form.querySelector('[name="id"]');
          if (id) id.value = String(chosen.variant.id);
        }
        form.bbgMotifSelection = function (showError) {
          const chosen = resolve();
          const valid = chosen.valid;
          if (!valid && showError) {
            error.textContent = chosen.motif && chosen.finish && chosen.voltage ? root.dataset.unavailableMessage : root.dataset.requiredMessage;
            error.hidden = false;
            if (!motif.value) summary.focus(); else if (!finish.value) finish.focus(); else if (!voltage.value) voltage.focus();
          }
          return valid ? chosen : null;
        };
        buttons.forEach(button => button.addEventListener('click',() => {
          motif.value = button.dataset.bbgDesign;
          text.textContent = motif.value;
          menu.open = false;
          update();
          summary.focus();
        }));
        finish.addEventListener('change',update);
        voltage.addEventListener('change',update);
        menu.addEventListener('keydown',event => { if(event.key === 'Escape') { menu.open = false; summary.focus(); } });
        form.addEventListener('submit',event => {
          if (!form.bbgMotifSelection(true)) { event.preventDefault(); event.stopImmediatePropagation(); }
        },true);
        update();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
    document.addEventListener('Section:Loaded',initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
